import React from "react";

const Chip = ({ children }) => (
    <span className="badge rounded-pill bg-secondary me-2 mb-2">{children}</span>
);

export default Chip;